import { createApp } from 'vue';

import { Quasar } from 'quasar';
import quasarUserOptions from './modules/quasar-user-options'

import JobApplication from './JobApplication/JobApplication.vue';

document.themeVueFrontendLoader = (base) => {
    if(!base) base = document;
    const appRoots = base.querySelectorAll('.dynamicVue:not(.initialized)');
    appRoots.forEach(root => {
        let app = createApp({});
        app.use(Quasar, quasarUserOptions)

        app.component('JobApplication', JobApplication);

        app.mount(root);
        //add class "initialized" to root element
        root.classList.add('initialized');
    });
}

document.addEventListener('DOMContentLoaded', () => {
    document.themeVueFrontendLoader();
});